import React, { Component } from "react";
import { Menu, Icon } from "antd";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";
import UserProfile from "./UserProfile";
import AppsNavigation from "./AppsNavigation";
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE
} from "../../constants/ThemeSetting";
import IntlMessages from "../../util/IntlMessages";
import { useSelector } from "react-redux";
import { fetchUser } from '../../util/API'
import { message } from "antd/lib/index";
import { fetchUserInfo } from '../../appRedux/actions/Auth'
import './style.less';

const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

const createNew = () => {
  localStorage.removeItem("uuid");
  localStorage.removeItem("edit_uuid");
}
const SidebarContentComp = (props) => {

  let { navStyle, themeType } = useSelector(({ settings }) => settings);
  let { pathname } = useSelector(({ common }) => common);

  const getNoHeaderClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR || navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
      return "gx-no-header-notifications";
    }
    return "";
  };
  const getNavStyleSubMenuClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      return "gx-no-header-submenu-popup";
    }
    return "";
  };
  const selectedKeys = pathname.substr(1);
  const defaultOpenKeys = selectedKeys.split('/')[0];

  let user = props.user.data
  if (!user) {
    return (
      <></>
    )
  }
  let info = user['LogedInUserInfo']

  const user_role = localStorage.getItem('user_role') ? localStorage.getItem('user_role') : "partner"
  const status = info.status ? info.status : "pending"
  const myprofile_link = '/detail/'.concat(info.uuid)

  const userEmail = info?.email || localStorage.getItem('user_email_id');
  const isAllowedEmail = userEmail === 'akshay.s@uniserved.com' || userEmail === 'neha@uniserved.com';

  return (
    <>
      <SidebarLogo />
      <div className="gx-sidebar-content">
        <div className={`gx-sidebar-notifications ${getNoHeaderClass(navStyle)}`}>
          <UserProfile info={info} />
        </div>
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            //defaultOpenKeys={[defaultOpenKeys,'vcomms']}
            selectedKeys={[selectedKeys]}
            theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
            mode="inline">

            {user_role !== 'qa' && user_role !== 'partner' && user_role !== 'agent' && user_role !== 'internal_agent' && user_role !== 'partner_employee' &&

              <Menu.Item key="dashboard">
                <Link to="/dashboard">
                  <i className="icon icon-dasbhoard" />
                  <span>Dashboard</span>
                </Link>
              </Menu.Item>}

            {user_role === 'admin' && (
              <Menu.Item key="partner-dashboard">
                <Link to="/partner-dashboard">
                  <i className="icon icon-dasbhoard" />
                  <span>Partner Dashboard</span>
                </Link>
              </Menu.Item>
            )}

            {user_role !== 'qa' && user_role !== 'partner' && user_role !== 'partner_employee' && <Menu.Item key="records">
              <Link to="/records"><i className="icon icon-check-square-o" />
                <span>Records</span></Link>
            </Menu.Item>}

            {user_role !== 'qa' && user_role !== 'partner' && user_role !== 'partner_employee' && <Menu.Item key="rejected">
              <Link to="/rejected"><i className="icon icon-close-circle" />
                <span>Rejected Records</span></Link>
            </Menu.Item>}

            {user_role === 'qa' && <Menu.Item key="registered-partners">
              <Link to="/registered-partners"><i className="icon icon-card" />
                <span>Registered Partners</span></Link>
            </Menu.Item>}

            {user_role === 'qa' && <Menu.Item key="qc/rejected">
              <Link to="/qc/rejected"><i className="icon icon-close-circle" />
                <span>Rejected Records</span></Link>
            </Menu.Item>}

            {user_role !== 'qa' && user_role !== 'partner' && user_role !== 'partner_employee' && <SubMenu key="vcomms" popupClassName={getNavStyleSubMenuClass(navStyle)}
              title={<span> <i className="icon icon-apps" />
                <Link to="/vcomms">

                  <span>VCOMMS</span>
                </Link>
              </span>}>

              <Menu.Item key="jobs">
                <Link to="/jobs">
                  <i className="icon icon-feedback" />
                  <span>Define Jobs</span>
                </Link>
              </Menu.Item>
              <Menu.Item key="jobs-filter">
                <Link to="/jobs-filter">
                  <i className="icon icon-filter" />
                  <span>Filter</span>
                </Link>
              </Menu.Item>
              <Menu.Item key="sendmail">
                <Link to="/sendmail">
                  <i className="icon icon-email" />
                  <span>Send Email</span>
                </Link>
              </Menu.Item>
            </SubMenu>}


            {user_role === 'partner' && status !== "pending" && <Menu.Item key="detail">
              <Link to={myprofile_link}><i className="icon icon-check-square-o" />
                <span>My Profile</span></Link>
            </Menu.Item>}

            {/* {user_role === 'partner' && status !== "pending" && <Menu.Item key="rate-card">
              <Link to="/rate-card">
                <Icon type="form" />
                <span>Rate Card</span>
              </Link>
            </Menu.Item> } */}
            {user_role === 'partner' && status !== "pending" && <Menu.Item key="partner-tickets">
              <Link to="/partner-tickets">
                <i className="icon icon-tag" />
                <span>Tickets</span>
              </Link>
            </Menu.Item>}
            {user_role === 'partner' && status !== "pending" && <Menu.Item key="client-payables">
              <Link to="/client-payables">
                <i className="icon icon-revenue-new" />
                <span>Payments status</span>
              </Link>
            </Menu.Item>}

            {user_role === 'qa' && <Menu.Item key="records">
              <Link to="/records"><i className="icon icon-check-square-o" />
                <span>New Records</span></Link>
            </Menu.Item>}

            {user_role === 'qa' && <Menu.Item key="redo">
              <Link to="/redo"><i className="icon icon-icon" />
                <span>Re Submitted Records</span></Link>
            </Menu.Item>}

            {/* {user_role === 'qa' &&   <Menu.Item key="skill">
                <Link to="/skill"><i className="icon icon icon-all-contacts"/>
                  <span>Review Skill Tags</span></Link>
              </Menu.Item>} */}
            {user_role === 'qa' && <Menu.Item key="metadata">
              <Link to="/metadata"><i className="icon icon icon-all-contacts" />
                <span>Review Metadatas & Skills</span></Link>
            </Menu.Item>}
            {user_role === 'agent' && <Menu.Item key="registration">
              <Link to="/registration" onClick={createNew}><i className="icon icon-apps" />
                <span>Create New Record</span></Link>
            </Menu.Item>}
            {user_role === 'internal_agent' && <Menu.Item key="registration">
              <Link to="/registration" onClick={createNew}><i className="icon icon-apps" />
                <span>Create New Record</span></Link>
            </Menu.Item>}
            {(isAllowedEmail || (user_role !== 'qa' && user_role !== 'partner' && user_role !== 'agent' && user_role !== 'internal_agent' && user_role !== 'partner_employee')) &&

              <Menu.Item key="audit-trail">
                <Link to="/audit-trail">
                  <Icon type="audit" />
                  <span>Audit Trail</span>
                </Link>
              </Menu.Item>}
             {(user_role === 'internal_agent' || user_role ==='admin') &&
              <Menu.Item key="vendor-tasks">
                <Link to="/vendor-tasks">
                  <Icon type="mail" />
                  <span>Tasks</span>
                </Link>
              </Menu.Item>}
            {user_role !== 'qa' && user_role !== 'partner' && user_role !== 'agent' && user_role !== 'partner_employee' && <Menu.Item key="pincode-management">
              <Link to="/pincode-management"><i className="icon icon-location" />
                <span>Pincode Management</span></Link>
            </Menu.Item>}
            {user_role !== 'qa' && user_role !== 'partner' && user_role !== 'agent' && user_role !== 'partner_employee' && <Menu.Item key="coverage">
              <Link to="/coverage">
                <Icon type="apartment" />
                <span>Coverage</span>
              </Link>
            </Menu.Item>}
            {user_role !== 'qa' && user_role !== 'partner' && user_role !== 'agent' && user_role !== 'partner_employee' && <Menu.Item key="all-interactions">
              <Link to="/all-interactions"><i className="icon icon-listing-dbrd" />
                <span>All Interactions</span></Link>
            </Menu.Item>}
            {user_role !== 'qa' && user_role !== 'partner' && user_role !== 'agent' && user_role !== 'partner_employee' && <Menu.Item key="interactions">
              <Link to="/interactions"><i className="icon icon-chat-new" />
                <span>Interaction Scopes</span></Link>
            </Menu.Item>}
            {user_role === 'internal_agent' && <Menu.Item key="rate-cards">
              <Link to="/rate-cards"><i className="icon icon-card" />
                <span>Rate Cards</span></Link>
            </Menu.Item>}
            {user_role !== 'qa' && user_role !== 'partner' && user_role !== 'partner_employee' && <Menu.Item key="vendor-collections">
              <Link to="/vendor-collections"><i className="icon icon-card" />
                <span>Data Collections</span></Link>
            </Menu.Item>}
            {user_role !== 'qa' && user_role !== 'partner' && user_role !== 'agent' && user_role !== 'partner_employee' ? <Menu.Item key="vendor-data-review">
              <Link to="/vendor-data-review">
                <Icon type="project" />
                <span>Partner Data Review</span>
              </Link>
            </Menu.Item> : ""}
            {user_role !== 'qa' && user_role !== 'partner' && user_role !== 'partner_employee' && <Menu.Item key="techlocal-collections">
              <Link to="/techlocal-collections"><i className="icon icon-card" />
                <span>Techlocal Collections</span></Link>
            </Menu.Item>}
            {(user_role === 'partner' || user_role === 'partner_employee') && <Menu.Item key="account-options" style={{alignItems: 'center'}}>
              <Link to="/account-options" >
                <i className="icon icon-user-o" /><span >Account Options</span></Link>
            </Menu.Item>}
            {(user_role === 'partner' || user_role === 'partner_employee') && <Menu.Item key="exchange-transactions" style={{alignItems: 'center'}}>
              <Link to="/exchange-transactions" >
                <Icon type="project" />
                <span >Exchange Transactions</span></Link>
            </Menu.Item>}
            {user_role !== 'qa' && user_role !== 'partner' && user_role !== 'partner_employee' && <Menu.Item key="additional-profiling">
              <Link to="/additional-profiling" >
                <Icon type="project" />
                <span >Additional Profiling</span></Link>
            </Menu.Item>}
          </Menu>
        </CustomScrollbars>
      </div>
    </>
  );
};



class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: "",
    };
    this.getUserDetails()
  }


  getUserDetails = () => {

    fetchUser()
      .then(res => {
        if (res.data['status'] === 200) {
          this.setState({ cloader: false, userData: res });
          this.props.dispatch(fetchUserInfo(res['data']['LogedInUserInfo']));
          localStorage.setItem('user_full_name', res['data']['LogedInUserInfo'].fullname);
          localStorage.setItem('user_email_id', res['data']['LogedInUserInfo'].email);
          localStorage.setItem('user_uuid', res['data']['LogedInUserInfo'].uuid);
          localStorage.setItem('user_phone', res['data']['LogedInUserInfo'].phone);
        } else {
          this.setState({ cloader: false });
          message.error("Something went wrong ! please try again.")
        }
      })
      .catch(error => {
        this.setState({ cloader: false });
        // message.error(error.toString())
      });
  }

  render() {
    return (
      <SidebarContentComp user={this.state.userData} />
    );
  }
}
const mapStateToProps = ({ auth }) => {
  const { loader, alertMessage, showMessage, authUser, logedInUser } = auth;
  return { loader, alertMessage, showMessage, authUser, logedInUser }
};

SidebarContentComp.propTypes = {};
export default connect(mapStateToProps,)(SidebarContent);
